import * as tslib_1 from "tslib";
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { Dropdown, DropdownMenuItemType, } from 'office-ui-fabric-react/lib/Dropdown';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { FONT_NAME_LIST, FONT_SIZES, getFontSizeInPoints, getFontSizeFromSizeOrIndex, } from 'owa-format-options';
import { getComposeFormat } from 'owa-editor/lib/utils/getDefaultComposeFormat';
import FormatButton from './FormatButton';
import ColorPickerButton from './ColorPickerButton';
import selectFontFamilyOption from '../actions/selectFontFamilyOption';
import selectFontSizeOption from '../actions/selectFontSizeOption';
import selectFormattingOption from '../actions/selectFormattingOption';
import selectTextColorOption from '../actions/selectTextColorOption';
import { OptionDescription } from 'owa-options-controls';
var styles = require('./MessageFormatFull.scss');
var ComposeStyles = /** @class */ (function (_super) {
    tslib_1.__extends(ComposeStyles, _super);
    function ComposeStyles(props) {
        var _this = _super.call(this, props) || this;
        var dividerIndex = 0;
        _this.fontNameItems = FONT_NAME_LIST.map(function (font) {
            if (font.name === '-') {
                return {
                    key: "divider_" + dividerIndex++,
                    itemType: DropdownMenuItemType.Divider,
                    text: '-',
                };
            }
            else {
                return {
                    key: font.name,
                    text: font.name,
                };
            }
        });
        _this.fontSizeItems = FONT_SIZES.map(function (size, index) { return ({
            key: getFontSizeFromSizeOrIndex(size),
            text: getFontSizeInPoints(size),
        }); });
        return _this;
    }
    ComposeStyles.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var defaultFontFamily = getFallbackValueIfNull(optionStore.fontFamily, userOptions.ComposeFontName);
        var defaultFontSize = getFallbackValueIfNull(getFontSizeFromSizeOrIndex(optionStore.fontSize), getFontSizeFromSizeOrIndex(userOptions.ComposeFontSize));
        var isBold = getFallbackValueIfNull(optionStore.isFontBold, (userOptions.ComposeFontFlags & 1 /* Bold */) === 1 /* Bold */);
        var isItalic = getFallbackValueIfNull(optionStore.isFontItalic, (userOptions.ComposeFontFlags & 2 /* Italic */) === 2 /* Italic */);
        var isUnderline = getFallbackValueIfNull(optionStore.isFontUnderline, (userOptions.ComposeFontFlags & 4 /* Underline */) === 4 /* Underline */);
        var textStyles = this.getFormatStyles(defaultFontFamily, defaultFontSize, getFallbackValueIfNull(optionStore.fontColor, userOptions.ComposeFontColor), isBold, isItalic, isUnderline);
        return (React.createElement("div", { className: styles.textFormat },
            React.createElement("div", { className: styles.formatBar },
                React.createElement(Dropdown, { selectedKey: defaultFontFamily, options: this.fontNameItems, className: styles.fontDropDown, onChanged: this.onFontFamilyChanged }),
                React.createElement(Dropdown, { selectedKey: defaultFontSize, options: this.fontSizeItems, className: styles.sizeDropDown, onChanged: this.onFontSizeChanged }),
                React.createElement(FormatButton, { type: "bold", isSelected: isBold, onClick: this.onBoldClicked }),
                React.createElement(FormatButton, { type: "italic", isSelected: isItalic, onClick: this.onItalicClicked }),
                React.createElement(FormatButton, { type: "underline", isSelected: isUnderline, onClick: this.onUnderlineClicked }),
                React.createElement(ColorPickerButton, { onSelectColor: selectTextColorOption })),
            React.createElement("div", { className: styles.sampleText, style: textStyles },
                React.createElement(OptionDescription, null, strings.options_format_sampleText_1),
                React.createElement(OptionDescription, null, strings.options_format_sampleText_2))));
    };
    ComposeStyles.prototype.onFontFamilyChanged = function (option, index) {
        selectFontFamilyOption(option.key);
    };
    ComposeStyles.prototype.onFontSizeChanged = function (option, index) {
        selectFontSizeOption(option.key);
    };
    ComposeStyles.prototype.onBoldClicked = function (isSelected) {
        selectFormattingOption('isFontBold', isSelected);
    };
    ComposeStyles.prototype.onItalicClicked = function (isSelected) {
        selectFormattingOption('isFontItalic', isSelected);
    };
    ComposeStyles.prototype.onUnderlineClicked = function (isSelected) {
        selectFormattingOption('isFontUnderline', isSelected);
    };
    ComposeStyles.prototype.getFormatStyles = function (fontFamily, fontSize, fontColor, isBold, isItalic, isUnderline) {
        var composeFormat = getComposeFormat(fontFamily, fontSize, fontColor, 0);
        return {
            fontFamily: composeFormat.fontFamily,
            fontSize: composeFormat.fontSize,
            color: composeFormat.textColor,
            fontWeight: isBold ? 'bold' : undefined,
            fontStyle: isItalic ? 'italic' : undefined,
            textDecoration: isUnderline ? 'underline' : undefined,
        };
    };
    ComposeStyles = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () { return getUserConfiguration().UserOptions; },
        })
    ], ComposeStyles);
    return ComposeStyles;
}(React.Component));
export default ComposeStyles;
//# sourceMappingURL=ComposeStyles.js.map